import React, { useEffect } from "react";
import useDebounce from "@clave/use-debounce";
import usersApiClient from "../../../login-register/UsersApiClient";
import styles from "../popup.module.scss";
import { getConstraints } from "../../../validation/common";
import { getCurrentLanguage } from "../../../utils/currentLanguage";
export default function AddressEdit({ strings, handleInputChange, validateInput, error, address, setAddress, countries, }) {
    const postalCodeDebounced = useDebounce(address.postalCode, 600);
    const localizedConstraints = getConstraints(getCurrentLanguage());
    const getPostalCode = (postalCode) => {
        var _a, _b;
        if (postalCode.length >= localizedConstraints.PostalCode.length.minimum) {
            const countryCode = (_b = (_a = countries.find(x => x.id == address.countryId)) === null || _a === void 0 ? void 0 : _a.countryCode) !== null && _b !== void 0 ? _b : 'NO';
            usersApiClient.getPostalDefinition(postalCode, countryCode).then((data) => {
                if (data) {
                    setAddress((prevState) => ({
                        ...prevState,
                        city: data === null || data === void 0 ? void 0 : data.city,
                    }));
                }
            });
        }
    };
    useEffect(() => {
        getPostalCode(postalCodeDebounced);
    }, [postalCodeDebounced]);
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", { className: "heading1" },
            strings.edit,
            " ",
            strings.deliveryAddress),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "line1" }, strings.streetName),
            React.createElement("input", { name: "line1", value: address.line1, onChange: (e) => handleInputChange(e, true), onBlur: (e) => validateInput(e.target.name, true) }),
            React.createElement("span", { className: styles.error }, error.line1Err)),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "line2" }, strings.line2),
            React.createElement("input", { name: "line2", value: address.line2, onChange: (e) => handleInputChange(e, true), onBlur: (e) => validateInput(e.target.name, true) })),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "countryId" }, strings.country),
            React.createElement("select", { name: "countryId", value: address.countryId, onChange: (e) => handleInputChange(e, true) }, countries.map((country) => (React.createElement("option", { key: country.id, value: country.id }, country.displayName)))),
            React.createElement("span", { className: styles.error }, error.countryIdErr)),
        React.createElement("div", { className: "input-group-row" },
            React.createElement("div", { className: "input-group flex-half postal" },
                React.createElement("label", { htmlFor: "postalCode" }, strings.postalCode),
                React.createElement("input", { name: "postalCode", className: "inputField", type: "text", value: address.postalCode, onChange: (e) => handleInputChange(e, true), onBlur: (e) => validateInput(e.target.name, true) }),
                React.createElement("span", { className: styles.error }, error.postalCodeErr)),
            React.createElement("div", { className: "input-group flex-half" },
                React.createElement("label", { htmlFor: "city" }, strings.city),
                React.createElement("input", { name: "city", className: "inputField", type: "text", value: address.city, onChange: (e) => handleInputChange(e, true), onBlur: (e) => validateInput(e.target.name, true) }),
                React.createElement("span", { className: styles.error }, error.cityErr)))));
}
